import React from 'react';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';

function PaperComponent(props:any) {
  const nodeRef = React.useRef<HTMLDivElement>(null);

  return (
    <Draggable
      nodeRef={nodeRef}
      cancel={'[class*="MuiDialogContent-root"],[class*="MuiButtonBase-root"]'}
    >
      <Paper ref={nodeRef} {...props} />
    </Draggable>
  );
}
const enableDragging = {PaperComponent:PaperComponent};
export {enableDragging};
export default PaperComponent;
